const servicesidlogin = (state = [], action) => {
    switch (action.type) {
      case 'SERVICELOGINID':
      return {
          type: "SERVICELOGINID",
          servicesid: action.servicesid
        }
      default:
        return state
    }
  }
  
  export default servicesidlogin